export const ViewRequestFormEmployeeDefaultValue = form => {
  const StartdateDefault = new Date();
  StartdateDefault.setMinutes('00');
  StartdateDefault.setHours('10');
  StartdateDefault.setSeconds('00');

  const EnddateDefault = new Date();
  EnddateDefault.setMinutes('00');
  EnddateDefault.setHours('11');
  EnddateDefault.setSeconds('00');
  return {
    service_id: form?.service_id,
    service: form?.service,
    name: form?.name,
    email: form?.email,
    acceptable_hours: form?.acceptable_hours,
    initialAssignments:
      form?.initialAssignments?.length > 0
        ? form?.initialAssignments?.map(e => {
            const Startdate = new Date();
            Startdate.setHours(
              e?.['Start Time']?.includes('pm')
                ? +`${e?.['Start Time']?.match(/\d+/)?.[0]}` == 12
                  ? `${e?.['Start Time']?.match(/\d+/)?.[0]}`
                  : +`${e?.['Start Time']?.match(/\d+/)?.[0]}` + 12
                : +`${e?.['Start Time']?.match(/\d+/)?.[0]}`,
            );
            Startdate.setMinutes(`${e?.['Start Time']?.match(/:(\d+)/)?.[0].replace(':', '')}`);
            Startdate.setSeconds('00');
            const Enddate = new Date();
            Enddate.setHours(
              e?.['End Time']?.includes('pm')
                ? +`${e?.['End Time']?.match(/\d+/)?.[0]}` == 12
                  ? +`${e?.['End Time']?.match(/\d+/)?.[0]}`
                  : +`${e?.['End Time']?.match(/\d+/)?.[0]}` + 12
                : +`${e?.['End Time']?.match(/\d+/)?.[0]}`,
            );
            Enddate.setMinutes(`${e?.['End Time']?.match(/:(\d+)/)?.[0].replace(':', '')}`);
            Enddate.setSeconds('00');
            return {
              id: e?.id,
              date: e?.date,
              start_time: e?.['Start Time'] ? Startdate : StartdateDefault,
              end_time: e?.['End Time'] ? Enddate : EnddateDefault,
            };
          })
        : [{ start_time: StartdateDefault, end_time: EnddateDefault }],
    observations:
      form?.observations?.length > 0
        ? form?.observations?.map(e => {
            const Startdate = new Date();
            Startdate.setHours(
              e?.['Start Time']?.includes('pm')
                ? +`${e?.['Start Time']?.match(/\d+/)?.[0]}` == 12
                  ? `${e?.['Start Time']?.match(/\d+/)?.[0]}`
                  : +`${e?.['Start Time']?.match(/\d+/)?.[0]}` + 12
                : +`${e?.['Start Time']?.match(/\d+/)?.[0]}`,
            );
            Startdate.setMinutes(`${e?.['Start Time']?.match(/:(\d+)/)?.[0].replace(':', '')}`);
            Startdate.setSeconds('00');
            const Enddate = new Date();
            Enddate.setHours(
              e?.['End Time']?.includes('pm')
                ? +`${e?.['End Time']?.match(/\d+/)?.[0]}` == 12
                  ? +`${e?.['End Time']?.match(/\d+/)?.[0]}`
                  : +`${e?.['End Time']?.match(/\d+/)?.[0]}` + 12
                : +`${e?.['End Time']?.match(/\d+/)?.[0]}`,
            );
            Enddate.setMinutes(`${e?.['End Time']?.match(/:(\d+)/)?.[0].replace(':', '')}`);
            Enddate.setSeconds('00');
            return {
              id: e?.id,
              date: e?.date,
              start_time: e?.['Start Time'] ? Startdate : StartdateDefault,
              end_time: e?.['End Time'] ? Enddate : EnddateDefault,
            };
          })
        : [{ start_time: StartdateDefault, end_time: EnddateDefault }],
    // hourly_rate: form?.hourly_rate,
    formFields: form?.formFields?.map(({ id, name, label, type, value, options_selected }) => ({
      id: id,
      name: name,
      label: label,
      type: type,
      value: value,
      options:
        type === 'checkbox'
          ? options_selected?.map(elem => ({
              name: elem?.name,
              [elem?.name]: elem?.[elem?.name] === 'false' ? false : elem?.[elem?.name],
              // a:true
            }))
          : null,
    })),
  };
};

export default ViewRequestFormEmployeeDefaultValue;
